<template>
    <div class="banner">
        <swiper
            :options="swiperOption"
            v-if="banner.length > 0"
        >
            <swiper-slide
                v-for="(item, index) in banner"
                :key="index"
            >
                <a
                    :href="item.redirect"
                    target="_blank"
                >
                    <img
                        class="space-img"
                        :src="item.img"
                        alt=""
                    >
                </a>
            </swiper-slide>
            <div
                class="swiper-pagination swiper-pagination-bullets"
                slot="pagination"
            > </div>
        </swiper>
    </div>
</template>

<script>
// 必须引用
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
export default {
    components: {
        swiper,
        swiperSlide
    },
    props: {
        banner: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 1,
                loop: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            }
        };
    }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner {
    width: 280px;
    height: 360px;
    border-radius:8px;
    margin-top: 16px;
}

.space-img,img {
    width: 280px;
    height: 360px;
    border-radius:8px;
}

.swiper-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 20px;
    height: 20px;
}

>>> .swiper-pagination-bullet {
    background: gray9;
    opacity: 1;
    width: 10px;
    height: 10px;
}

>>> .swiper-pagination-bullet-active {
    border-radius: 15px;
    background: white;
}
</style>
